import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#001a0d] py-12 px-4" data-id="element-288">
      <div className="max-w-5xl mx-auto" data-id="element-289">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-6 mb-12 text-center" data-id="element-290">
          <div data-id="element-291">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-292">
              +1.200
            </div>
            <div className="text-[#00E676] text-sm font-semibold mt-1" data-id="element-293">
              docentes confían
            </div>
          </div>
          <div data-id="element-294">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-295">6</div>
            <div className="text-[#00E676] text-sm font-semibold mt-1" data-id="element-296">
              Tomos listos
            </div>
          </div>
          <div data-id="element-297">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-298">6</div>
            <div className="text-[#00E676] text-sm font-semibold mt-1" data-id="element-299">
              Bonos incluidos
            </div>
          </div>
          <div data-id="element-300">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-301">
              4.9/5
            </div>
            <div className="text-[#00E676] text-sm font-semibold mt-1" data-id="element-302">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-303">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-304">🇦🇷</div>
            <div className="text-[#00E676] text-sm font-semibold mt-1" data-id="element-305">
              Todo el país — secundaria
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-306">
          <div className="flex items-start gap-3 bg-black/40 border border-[#00E676]/20 rounded-xl p-4" data-id="element-307">
            <div className="w-10 h-10 rounded-full bg-[#00E676]/20 flex items-center justify-center text-[#00E676] font-black text-sm flex-shrink-0" data-id="element-308">
              MG
            </div>
            <div data-id="element-309">
              <div className="text-[#00E676] text-xs mb-1" data-id="element-310">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-311">
                "Organicé todo el año de Biología en una tarde. Nunca más llegué
                sin material al aula."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-312">
                — Mariela G., Córdoba | Docente de Biología Secundaria
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00E676]/20 rounded-xl p-4" data-id="element-313">
            <div className="w-10 h-10 rounded-full bg-[#00E676]/20 flex items-center justify-center text-[#00E676] font-black text-sm flex-shrink-0" data-id="element-314">
              LP
            </div>
            <div data-id="element-315">
              <div className="text-[#00E676] text-xs mb-1" data-id="element-316">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-317">
                "Las secuencias didácticas son exactamente lo que necesitaba. El
                solucionario me ahorra horas cada semana."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-318">
                — Laura P., Rosario | Docente de Biología 1º a 4º año
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00E676]/20 rounded-xl p-4" data-id="element-319">
            <div className="w-10 h-10 rounded-full bg-[#00E676]/20 flex items-center justify-center text-[#00E676] font-black text-sm flex-shrink-0" data-id="element-320">
              RM
            </div>
            <div data-id="element-321">
              <div className="text-[#00E676] text-xs mb-1" data-id="element-322">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-323">
                "Nunca más llegué sin material. Mis clases de 6º año sobre
                ambiente y cambio climático por fin enganchan de verdad."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-324">
                — Roberto M., Buenos Aires | Docente de Biología Secundaria
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}